<template>
  <div class="container-fluid">
    <h5>Photos &amp; Videos</h5>

    <div class="vx-row mb-6">
      <TypedSurveyImages 
        v-if="isMounted" 
        :item="question.configMediaImage" 
        :assetUrl="this.surveyType + '/' + this.surveyId + '?moduleId=' + this.moduleId + '&lessonId=' + this.lessonId + '&questionId=' + this.questionId + '&config=MediaImage'"
        style="width: 100%;" />
    </div>

  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import TypedSurveyImages from "./../../TypedSurveyImages.vue";

export default {
  name: "QuestionConfigMediaImage",
  components: {TypedSurveyImages},
  directives: {
  },
  props: ['question'],
  data() {
    return {
      isMounted: false,

      surveyType: '',
      surveyId: '',
      moduleId: '',
      lessonId: '',
      questionId: '',
    };
  },
  mounted() {
    this.surveyType = this.$route.params.surveyType;
    this.surveyId = this.$route.params.surveyId;
    this.moduleId = this.$route.params.moduleId;
    this.lessonId = this.$route.params.lessonId;
    this.questionId = this.$route.params.questionId;

    console.log(this.surveyType + '/' + this.surveyId + '?moduleId=' + this.moduleId + '&lessonId=' + this.lessonId + '&questionId=' + this.questionId + '&config=MediaImage');

    if (!this.question.configMediaImage || this.question.configMediaImage === null) {
        this.question.configMediaImage = {
            imageUrl: '',
            imageUrls: []
        };
    }

    this.isMounted = true;
  },
  beforeDestroy: function() {
  },
  methods: {}
};
</script>